// @flow
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import UserTemplate from 'components/user/UserTemplate';
import PageTemplate from 'components/base/PageTemplate';
import OrderListTemplateContainer from 'containers/order/OrderListTemplateContainer';

type Props = {};

class OrderList extends Component<Props> {
  render() {
    return (
      <PageTemplate>
        <header>
          <MainHeadContainer />
          <MainMobileHeadContainer />
        </header>
        <UserTemplate>
          <Helmet>
            <title>주문 목록 | 캐시바이</title>
          </Helmet>
          <OrderListTemplateContainer />
        </UserTemplate>
        <MainMobileFooter />
      </PageTemplate>
    );
  }
}

export default OrderList;



// WEBPACK FOOTER //
// ./src/pages/OrderList.js